import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { StyleState } from '../model/BoardSearch'

//* 초기 상태
const initialState: StyleState = {
    theme:'default'
};

const style = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setModel(state, action: PayloadAction<StyleState>) {
            state = {
                ...state,
                theme: action.payload.theme
            };
            return state;
        },
        //* 초기화 하기
        init(state) {
            state = initialState;
            return state;
        }
    }
});

export const styleActions = {...style.actions};

export default style;
